import { isLocal, isStage } from '../configs/env';

const stageUpgrades = [
  {
    from: 25,
    to: 200,
    productId: 8329493217506,
    variantId: 44911325315298,
  },
  {
    from: 25,
    to: 300,
    productId: 8329493217506,
    variantId: 44911325348066,
  },
  {
    from: 25,
    to: 450,
    productId: 8329493217506,
    variantId: 44911325380834,
  },
  {
    from: 25,
    to: 800,
    productId: 8329493217506,
    variantId: 44911325413602,
  },
  {
    from: 25,
    to: 1000,
    productId: 8329493217506,
    variantId: 44911325446370,
  },
  {
    from: 50,
    to: 100,
    productId: 8329492988130,
    variantId: 44911324791010,
  },
  {
    from: 50,
    to: 200,
    productId: 8329492988130,
    variantId: 44911324823778,
  },
  {
    from: 50,
    to: 300,
    productId: 8329492988130,
    variantId: 44911324856546,
  },
  {
    from: 50,
    to: 450,
    productId: 8329492988130,
    variantId: 44911324889314,
  },
  {
    from: 50,
    to: 800,
    productId: 8329492988130,
    variantId: 44911324922082,
  },
  {
    from: 50,
    to: 1000,
    productId: 8329492988130,
    variantId: 44911324954850,
  },
  {
    from: 100,
    to: 200,
    productId: 8329492758754,
    variantId: 44911324233954,
  },
  {
    from: 100,
    to: 300,
    productId: 8329492758754,
    variantId: 44911324266722,
  },
  {
    from: 100,
    to: 450,
    productId: 8329492758754,
    variantId: 44911324299490,
  },
  {
    from: 100,
    to: 800,
    productId: 8329492758754,
    variantId: 44911324332258,
  },
  {
    from: 100,
    to: 1000,
    productId: 8329492758754,
    variantId: 44911324365026,
  },
  {
    from: 200,
    to: 300,
    productId: 8270576812258,
    variantId: 44707126542562,
  },
  {
    from: 200,
    to: 450,
    productId: 8270576812258,
    variantId: 44707126575330,
  },
  {
    from: 200,
    to: 800,
    productId: 8270576812258,
    variantId: 44707126608098,
  },
  {
    from: 200,
    to: 1000,
    productId: 8270576812258,
    variantId: 44707126640866,
  },
  {
    from: 300,
    to: 450,
    productId: 8270576845026,
    variantId: 44707126673634,
  },
  {
    from: 300,
    to: 800,
    productId: 8270576845026,
    variantId: 44707126706402,
  },
  {
    from: 300,
    to: 1000,
    productId: 8270576845026,
    variantId: 44707126739170,
  },
  {
    from: 450,
    to: 800,
    productId: 8270576943330,
    variantId: 44707126837474,
  },
  {
    from: 450,
    to: 1000,
    productId: 8270576943330,
    variantId: 44707126870242,
  },
];

const prod25gb = [
  {
    from: 25,
    to: 200,
    productId: 7039339135133,
    variantId: 41089186168989,
  },
  {
    from: 25,
    to: 300,
    productId: 7039339135133,
    variantId: 41089186201757,
  },
  {
    from: 25,
    to: 450,
    productId: 7039339135133,
    variantId: 41089186267293,
  },
  {
    from: 25,
    to: 800,
    productId: 7039339135133,
    variantId: 41089186332829,
  },
  {
    from: 25,
    to: 1000,
    productId: 7039339135133,
    variantId: 41196526534813,
  },
];

const prod50gb = [
  {
    from: 50,
    to: 100,
    productId: 7039328518301,
    variantId: 41089155563677,
  },
  {
    from: 50,
    to: 200,
    productId: 7039328518301,
    variantId: 41089151369373,
  },
  {
    from: 50,
    to: 300,
    productId: 7039328518301,
    variantId: 41089151402141,
  },
  {
    from: 50,
    to: 450,
    productId: 7039328518301,
    variantId: 41089151434909,
  },
  {
    from: 50,
    to: 800,
    productId: 7039328518301,
    variantId: 41089151467677,
  },
  {
    from: 50,
    to: 1000,
    productId: 7039328518301,
    variantId: 41196545310877,
  },
];

const prod100gb = [
  {
    from: 100,
    to: 200,
    productId: 7039307251869,
    variantId: 41089093566621,
  },
  {
    from: 100,
    to: 300,
    productId: 7039307251869,
    variantId: 41089084850333,
  },
  {
    from: 100,
    to: 450,
    productId: 7039307251869,
    variantId: 41089084883101,
  },
  {
    from: 100,
    to: 800,
    productId: 7039307251869,
    variantId: 41089084915869,
  },
  {
    from: 100,
    to: 1000,
    productId: 7039307251869,
    variantId: 41196549734557,
  },
];

const prod200gb = [
  {
    from: 200,
    to: 300,
    productId: 7021997785245,
    variantId: 41044507230365,
  },
  {
    from: 200,
    to: 450,
    productId: 7021997785245,
    variantId: 41044507263133,
  },
  {
    from: 200,
    to: 800,
    productId: 7021997785245,
    variantId: 41044507295901,
  },
  {
    from: 200,
    to: 1000,
    productId: 7021997785245,
    variantId: 41196554616989,
  },
];

const prod300gb = [
  {
    from: 300,
    to: 450,
    productId: 7021999128733,
    variantId: 41044515192989,
  },
  {
    from: 300,
    to: 800,
    productId: 7021999128733,
    variantId: 41044515225757,
  },
  {
    from: 300,
    to: 1000,
    productId: 7021999128733,
    variantId: 41196563595421,
  },
];

const prod450gb = [
  {
    from: 450,
    to: 800,
    productId: 7021999849629,
    variantId: 41044517421213,
  },
  {
    from: 450,
    to: 1000,
    productId: 7021999849629,
    variantId: 41196570345629,
  },
];

const prod800gb = [
  {
    from: 800,
    to: 1000,
    productId: 7085996638365,
    variantId: 41196575686813,
  },
];

const prodUpgrades = [
  ...prod25gb,
  ...prod50gb,
  ...prod100gb,
  ...prod200gb,
  ...prod300gb,
  ...prod450gb,
  ...prod800gb,
];

export const upgradeDeviceMapping =
  isStage() || isLocal() ? stageUpgrades : prodUpgrades;
